module.exports = __webpack_public_path__ + "fonts/Franklin-gothic-heavy.9d5211f.ttf";